import { MxAlert } from '@marxa/devkit';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { AngularFirestore } from '@angular/fire/firestore';
// import { GdevAlert } from '../alert/alert.service';
import { Location } from '@angular/common';
import { AngularFireStorage } from '@angular/fire/storage';
import { ThemePalette } from '@angular/material/core';
import { Orientation } from './mat-carousel/carousel';
import { MxSlide, MxSliderConfig } from './mx-slider.model';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class MxSlider {


  sliderConfig: MxSliderConfig = {
    timings: "250ms ease-in",
    autoplay : true,
    interval: 5000,
    color: "primary",
    maxWidth: "auto",
    proportion: 30,
    slides: 5,
    loop: true,
    hideArrows: false,
    hideIndicators: false,
    useKeyboard: true,
    useMouseWheel: false,
    orientation: "ltr",
    maintainAspectRatio: true,
    slideHeight:'100%'
  }

  $sliderConfig: BehaviorSubject<MxSliderConfig> = new BehaviorSubject(this.sliderConfig)
  slides$: Observable<any> = new Observable()
  public collection: string = 'marxa-devs'

  constructor (
    private fs: AngularFirestore,
    private storage: AngularFireStorage,
    private alert: MxAlert,
    private location: Location
  ) {
  }

  async addSlide(slide: MxSlide, collection?: string) {
    this.collection = collection || this.collection
    const slidesRef = this.fs.collection(`${collection || this.collection}/slider/slides` )
    var nuSlide = await slidesRef.add( slide )
    slidesRef.doc(nuSlide.id).update({id: nuSlide.id})
    return
  }

  getSlidesList(collection?: string) {
    return this.fs.collection<MxSlide>( `${collection || this.collection}/slider/slides` )
    .valueChanges()
  }


  async loadSlides(collection?: string) {
    try {

      const sliderRef = this.fs.collection(`${collection || this.collection}/slider/slides`)
        .ref.where('activado', '==', true)


      const slidesDocs = await sliderRef.get()
      const slides: any[] = []

      slidesDocs.forEach( slide => {
        slides.push(slide.data() as MxSlide)
      } )

      return slides
    } catch (error) {
      console.error(error)
      return []
    }
  }

  async updateSlide(slide: MxSlide, collection?: string) {
    const slidesRef = this.fs.collection(
      `${collection || this.collection}/slider/slides`
    ).ref
    slidesRef.doc( slide.id ).update( slide )
    // this.alertas.sendFloatNotification('Slide modificada')
    return
  }


  async deleteSlide( slide: MxSlide, collection?: string ) {
    await this.fs.collection( `${collection || this.collection}/slider/slides` ).ref
      .doc( slide.id ).delete()
    await this.storage.storage.refFromURL( slide.imageURL ).delete()
    // this.alertas.sendFloatNotification('Se borró la slide')
    return
  }

  loadConfiguration( collection?: string) {
    const sliderRef = this.fs.collection( collection || this.collection ).doc( 'slider' )
    return sliderRef.get().pipe(map(doc => {
        let config  = doc.data() as MxSliderConfig
        this.$sliderConfig.next(config)
        return config
      })
    )
  }

  async setSliderConfiguration( config: MxSliderConfig, collection?: string ) {
    try {
      const sliderRef = this.fs.collection( collection || this.collection ).ref.doc( 'slider' )
      await sliderRef.set( config, { merge: true } )
      this.alert.notify('Configuración guardada')
      return
    } catch ( error ) {
      console.error(error);
      return
    }
  }


}
